var _path, _g, _path2, _path3, _g2, _g3, _g4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrTable(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23,0L23,0A23,23 0,0 1,46 23L46,23A23,23 0,0 1,23 46L23,46A23,23 0,0 1,0 23L0,23A23,23 0,0 1,23 0z",
    strokeWidth: 1,
    fill: "#F4F5F7",
    stroke: "#EBEBEB",
    fillRule: "evenodd"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9608,21.2352l21.9378,0l0,10.9956l-21.9378,0z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M32.6266,29.8068L28.0617,29.8068C26.9153,29.8068 25.9864,28.8738 25.9864,27.7239L25.9864,21.2352L19.8733,21.2352L19.8733,27.7239C19.8733,28.8738 18.9443,29.8068 17.7979,29.8068L13.2335,29.8068C12.6277,29.7917 12.0985,30.215 11.979,30.811C11.8643,31.4706 12.3049,32.0981 12.9618,32.2128C13.032,32.225 13.1025,32.2312 13.1731,32.2308L32.6865,32.2308C33.3536,32.2332 33.8962,31.6924 33.8987,31.0231C33.899,30.9523 33.8933,30.881 33.8811,30.811C33.7611,30.215 33.232,29.7917 32.6266,29.8068",
    strokeWidth: 1,
    fill: "#BBC0C4",
    fillRule: "evenodd",
    stroke: "#00000000"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8733,30.8311l6.1196,0l0,-9.5959l-6.1196,0z",
    strokeWidth: 1,
    fill: "#BBC0C4",
    fillRule: "evenodd",
    stroke: "#00000000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8733,24.4161l6.1196,0l0,-3.1809l-6.1196,0z",
    strokeWidth: 1,
    fill: "#9EA6AE",
    fillRule: "evenodd",
    stroke: "#00000000"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8,14.3462l30,0l0,17.8846l-30,0z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M10.1153,16.1437L10.1153,15.4187C10.1153,14.8264 10.5939,14.3462 11.1842,14.3462L16.1717,14.3462C16.7617,14.3462 17.2402,14.8264 17.2402,15.4187L17.2402,16.1437C17.2402,16.7361 16.7617,17.2159 16.1717,17.2159L11.1842,17.2159C10.5939,17.2159 10.1153,16.7361 10.1153,16.1437",
    strokeWidth: 1,
    fill: "#E25D6F",
    fillRule: "evenodd",
    stroke: "#00000000"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8,14.3462l30,0l0,17.8846l-30,0z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M32.6865,32.2308L13.1731,32.2308C12.5065,32.2345 11.9627,31.6949 11.9586,31.0251C11.9586,31.0231 11.9586,31.021 11.9586,31.0186C11.9586,30.3493 12.4996,29.8068 13.1666,29.8068C13.169,29.8068 13.1711,29.8068 13.1731,29.8068L32.6865,29.8068C33.3536,29.8027 33.897,30.3423 33.9011,31.012C33.9011,31.0141 33.9011,31.0165 33.9011,31.0186C33.9011,31.6879 33.3601,32.2308 32.6931,32.2308C32.6906,32.2308 32.6886,32.2308 32.6865,32.2308",
    strokeWidth: 1,
    fill: "#BBC0C4",
    fillRule: "evenodd",
    stroke: "#00000000"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8,14.3462l30,0l0,17.8846l-30,0z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M37.1314,21.6032L8.8445,21.6032C8.3643,21.6032 7.9755,21.2127 7.9755,20.7313L7.9755,18.112C7.9755,17.6306 8.3643,17.2405 8.8445,17.2405L37.1314,17.2405C37.6112,17.2405 38,17.6306 38,18.112L38,20.7313C38,21.2127 37.6112,21.6032 37.1314,21.6032",
    strokeWidth: 1,
    fill: "#E98799",
    fillRule: "evenodd",
    stroke: "#00000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrTable);
export default __webpack_public_path__ + "static/media/or-table.ec129e2eaffac479fe044da2dfe2bfd6.svg";
export { ForwardRef as ReactComponent };